<!-- 入库出库-->
<template>
<div class="content-panel">
    <el-row :gutter="10" type="flex" justify="space-between" align="middle" class="breadcrumb-wrap">
        <el-col :span="20">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">{{msg('首页')}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/admin/inventory'}">{{msg('库存管理')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{msg('入库出库')}}</el-breadcrumb-item>
            </el-breadcrumb>
        </el-col>
    </el-row>
    <el-form ref="form" label-width="100px" style="margin-top: 25px; padding: 0px 20px;">
        <el-row>
            <el-col :xs="24" :sm="12">
                <el-form-item :label="msg('入库件数')">
                    <el-input type="number" v-model="inInvQty" @keyup.native.enter="()=>doEnter(0)">
                        <el-button slot="append" icon="el-icon-circle-check" @click="()=>doEnter(0)">填充</el-button>
                    </el-input>
                </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12">
                <el-form-item :label="msg('出库件数')">
                    <el-input type="number" v-model="outInvQty" @keyup.native.enter="()=>doEnter(1)">
                        <el-button slot="append" icon="el-icon-circle-check" @click="()=>doEnter(1)">填充</el-button>
                    </el-input>
                </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="4">
                <div style="text-align:left;margin-left:20px;margin-top:2px;">
                    <el-button type="primary" size="small"  @click="onSubmit"><i class="el-icon-check"></i><span>{{msg('提交')}}</span></el-button>
                </div>
            </el-col> -->
        </el-row>
    </el-form>
    <div class="table-wrap" :style="{height: (docHeight)+'px'}">
        <vxe-grid ref="dataTable" :height="docHeight" 
            export-config
            resizable border="full"
            size="mini"
            show-overflow highlight-hover-row
            highlight-current-row highlight-hover-column highlight-current-column
            :data="datas"
            :columns="columns"
            @cell-click="checkRow"
        ></vxe-grid>
    </div>

    <el-dialog :title="msg('入库')" :visible.sync="qtyVisiable" :fullscreen="isMinScreen" @opened="openQtyDg"
        :close-on-click-modal="false" 
            width="600px">
        <stock-qty-edit-dialog ref="qtyDg" :ids="detailId"  @close-dg="closeQtyDg"/>
    </el-dialog> 

    <el-dialog :title="msg('出库')" :visible.sync="qty1Visiable" :fullscreen="isMinScreen" @opened="openQty1Dg"
        :close-on-click-modal="false" 
            width="600px">
        <stock-qty-edit-dialog1 ref="qty1Dg" :ids="detailId"  @close-dg="closeQty1Dg"/>
    </el-dialog> 

</div>
</template>

<script>
import StockQtyEditDialog from "./StockQtyEditDialog.vue";
import StockQtyEditDialog1 from "./StockQtyEditDialog1.vue";
export default {
    name: "StockQtyEdit",
    components: {
        StockQtyEditDialog:StockQtyEditDialog,
        StockQtyEditDialog1:StockQtyEditDialog1
    },
    mounted(){
        this.init();
    },
    data(){
        return {
            datas: [],
            ids: null,
            columns: [],
            qtyVisiable:false,
            qty1Visiable:false,
            detailId:null,
            inInvQty: 0,
            outInvQty: 0,
        }
    },
    computed: {
        isMinScreen: { //是否小屏幕，浏览器
            get() {
                return this.$store.state.isMinScreen;
            }
        },
        docHeight: { //表格的高度
            get() {
                var height = this.$store.state.docHeight;
                return height - 220;
            }
        }
    },
    methods:{
        init(){
            this.ids = window.localStorage.getItem("qtyEditIds");
            this.buildColumns();
            this.getData();
        },
        openQtyDg(){
            this.$nextTick(() => {
                this.$refs.qtyDg.init();
            });
        },
        openQty1Dg(){
            this.$nextTick(() => {
                this.$refs.qty1Dg.init();
            });
        },
        closeQtyDg(){
            this.qtyVisiable = false;
            this.detailId = null;
            this.getData();
        },
        closeQty1Dg(){
            this.qty1Visiable = false;
            this.detailId = null;
            this.getData();
        },
        buildColumns(){
            this.columns = [
                // {type: 'seq', minWidth: 40,},
                {type: 'checkbox', minWidth: 40 ,fixed: 'left'},
                {field: 'id', title:this.msg('ID'), minWidth: 60, sortable: true},
                {field: 'code', title: this.msg('库存编号'), minWidth: 120, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'qty', title: this.msg('可用件数'), minWidth: 80, sortable: true,
                    filters:[{data: {type: 'has', isCase: false, name: ''}}],
                    filterRender:{name: 'FilterComplex'}
                },
                {field: 'inQty', title: this.msg('入库件数'), minWidth: 80, sortable: true,
                    slots: {
                        // 使用渲染函数
                        default: ({ row }) => {
                            return [
                                <span class="id-cell"><i class="in-edit el-icon-download"></i></span>
                            ]
                        }
                    }
                },
                {field: 'outQty', title: this.msg('出库件数'), minWidth: 80, sortable: true,
                    slots: {
                        // 使用渲染函数
                        default: ({ row }) => {
                            return [
                                <span class="id-cell"><i class="out-edit el-icon-upload2"></i></span>
                            ]
                        }
                    }
                },
                {field: 'spec', title: this.msg('规格'), minWidth: 120, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'sku', title: this.msg('SKU'), minWidth: 120, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'variationSku', title: this.msg('货号'), minWidth: 120, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
                {field: 'title', title: this.msg('货物标题'), minWidth: 160, sortable: true,
                    filters:[{data: {vals: [], sVal: ''}}],
                    filterRender:{name: 'FilterContent'}
                },
            ]
        },
        getData(){
            this.$axios.post(this.$kit.api.inventory.inoutStoreList, this.ids)
                .then((result) => {
                    if(result.status){
                        let ds = [];
                        let giveups = [];
                        result.data.forEach(s => {
                            if(s.status == 135){
                                giveups.push(s);
                            }else{
                                ds.push(s);
                            }
                        });
                        this.datas = ds;
                        if(giveups.length>0){
                            this.$message(this.msg('已弃件订单不能再进出入库操作！'));
                            // this.$message(this.fmt('单号：%s已弃件， 不能再进出入库操作！', [giveups.map(s => s.code).join(",")]));
                        }
                    }
                });
        },
        //点击行，选中行
        checkRow({row,rowIndex, $event, column, columnIndex}){
            //如果点击checkbox 则不处理
            let className = $event.target.className;
            // console.log(columnIndex);
            if(column.property == "inQty"){
                if(className.indexOf('in-edit')>-1){
                    this.inQty(row);
                }
            }else if(column.property == "outQty"){
                if(className.indexOf('out-edit')>-1){
                    this.outQty(row);
                }
            }
        },
        inQty(row){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length > 0){
                this.detailId = selectes.map(s => s.id).join(",");
            }else{
                this.detailId = row.id;
            }
            this.qtyVisiable = true;
        },
        outQty(row){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length > 0){
                this.detailId = selectes.map(s => s.id).join(",");
            }else{
                this.detailId = row.id;
            }
            this.qty1Visiable = true;
        },
        doEnter(type){
            var selectes = this.$refs.dataTable.getCheckboxRecords();
            if(selectes.length == 0){
                this.$message(this.msg('请选中一条数据进行操作'));
                return;
            }

            // console.log(type);

            let qty = null;
            if(type == 1){
                qty = this.outInvQty;
            }else{
                qty = this.inInvQty;
            }

            // console.log(qty, this.inInvQty, this.outInvQty);
            if(!qty || qty <= 0){
            this.$message(this.msg('请输入入库件数'));
                return;
            }
            let reg = new RegExp("^[0-9]*$");
            if(!reg.test(qty)){
                this.$message(this.msg('格式不正确，只能输入数字'));
                return;
            }

            this.$axios.post(this.$kit.api.inventory.updateInventoryQty, 
                    "invIds="+selectes.map(s => s.id).join(",")
                    +"&type="+type
                    +"&qty="+qty+"&remark=",
                    {headers: {'Content-Type' : 'application/x-www-form-urlencoded'}}
            ).then(result => {
                if(result.status){
                    this.$message(result.msg || this.msg('更新成功'));
                    this.getData();

                    if(this.type == 1) this.outInvQty = 0; 
                    else this.inInvQty = 0;

                }else{
                    this.$message(result.msg || this.msg('更新失败'));
                }
            })
           
        }

       

    }
}
</script>

<style lang="scss" scoped>

.table-wrap{
    width:100%;
    overflow:auto;
}
.in-edit{cursor:pointer; display:inline-block;}
.out-edit{cursor:pointer; display:inline-block;}

</style>
